/* eslint-disable react-hooks/exhaustive-deps */
import {
	List,
	ListItem,
	InputGroup,
	InputRightElement,
	HStack,
} from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import {
	useInviteParticipant,
	useSearchOrgContacts,
} from '../../../hooks/activity.hooks'
import { ActivityUsersRow } from '../../../components/globalComponents/activityUsersRow'
import { MdSearch } from 'react-icons/md'
import InputText from '../../../components/globalComponents/inputText'
import { useLanguageContext } from '../../../context/locale.context'

const Teams = ({
	activity,
	activeParticipants,

	onSetReload,
	inviteDelegate = false,
	addDelegate = null,
	data,
	setdata,
}) => {
	const { activity_id, activity_type_id, activity_type_category_id } = activity
	const { mutate: inviteMutate } = useInviteParticipant()
	const { mutate: searchContactMutate } = useSearchOrgContacts()
	const {
		state: { locale },
	} = useLanguageContext()
	const inviteUser = useCallback(
		({
			contact_asset_type_id,
			contact_asset_id,
			contact_first_name,
			contact_operating_asset_name,
			workforce_name,
		}) => {
			inviteMutate(
				{
					activity_id,
					activity_type_category_id: activity_type_category_id,
					activity_type_id,
					contact: {
						asset_type_id: contact_asset_type_id,
						asset_id: contact_asset_id,
						asset_first_name: contact_first_name,
						operating_asset_first_name: contact_operating_asset_name,
						workforce_name,
					},
				},
				{
					onSuccess: async data => {
						onSetReload()
					},
				}
			)
		}
	)
	const [search_string, setSerachString] = useState('')
	const loadContacts = useCallback(search_string => {
		searchContactMutate(
			{ search_string },
			{
				onSuccess: async data => {
					setdata(data)
				},
			}
		)
	})

	useEffect(() => {
		// loadContacts()
	}, [])

	useEffect(() => {
		if (!!search_string) {
			loadContacts(search_string)
		}
	}, [search_string])

	return (
		<List px={3} w='full' spacing={2} overflowY='scroll' overflowX='hidden'>
			<HStack spacing={2} justifyContent='flex-end' width='90%'>
				<InputGroup marginTop='2' ml='55%'>
					<InputText
						type='tel'
						width='100%'
						height='36px'
						fontSize='13px'
						fontStyle='normal'
						fontWeight='500'
						background='#FFFFFF'
						placeholder={locale['Search user...']}
						value={search_string}
						onChange={e => {
							setSerachString(e.target.value)
						}}
						_placeholder={{
							color: 'brand.700',
							opacity: '0.5',
						}}
						borderRadius='18px'
						border='none'
					/>
					<InputRightElement
						pointerEvents='none'
						color='green.500'
						children={<MdSearch fontSize='25' />}
					/>
				</InputGroup>
			</HStack>
			{data &&
				(data || []).map(u => {
					if (activeParticipants.includes(u.contact_asset_id)) {
						return null
					}
					return (
						<React.Fragment key={u.contact_asset_id}>
							<ListItem bg='white'>
								<ActivityUsersRow
									userType='team'
									user={u}
									data={data}
									inviteUser={inviteUser}
								/>
							</ListItem>
						</React.Fragment>
					)
				})}
		</List>
	)
}

export default Teams
